import React from "react"
import { Link } from "gatsby"

export const SubmenuLink = ({ label, link, additional_classes }) => {
  const is_partially_active = ({ isPartiallyCurrent }) => ({
    className: `navbar-item is-submenu${isPartiallyCurrent ? " is-currently-active" : ""}${!!additional_classes?.[0] ? ` ${additional_classes?.join(" ")}` : ""}`,
  })

  return (
    <Link to={link} getProps={is_partially_active}>
      <span className="header-link">{label}</span>
    </Link>
  )
}
